<template>
  <div>
    <CRow class="mb-3 search-panel">

      <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
        <label>Thao tác</label>
        <div class="dropdown btn-group" style="height: 36px;">
          <button class="btn">
            <div class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" v-model="actionData.model.selectedAll"
                  @change="changeSelectAll()" id="selectedAll" />
                <label class="custom-control-label" for="selectedAll"></label>
              </div>
            </div>
          </button>
          <button type="button" class="dropdown-toggle dropdown-toggle-split btn" data-toggle="dropdown"
            aria-expanded="false" aria-haspopup="true"></button>
          <div class="dropdown-menu">
            <button v-if="$hasAuthor('ROLE_ADMIN')" :disabled="actionData.model.listFileSelectedId.length === 0"
              class="dropdown-item"
              @click="setupSelectOneAction('action_list', null, null, null, typeActionList.DELETE_LIST)" color="danger">
              <CIcon name="cil-trash" class="mr-2" />
              Xóa tất cả
            </button>
            <button v-if="$hasAuthor('ROLE_ADMIN')" :disabled="actionData.model.listFileSelectedId.length === 0"
              class="dropdown-item"
              @click="setupSelectOneAction('action_list', null, null, null, typeActionList.ACCEPT_LIST)" color="danger">
              <i class="fa fa-check mr-2" style="font-size: 1rem!important;"></i>
              Duyệt
            </button>
            <button v-if="$hasAuthor('ROLE_ADMIN')" :disabled="actionData.model.listFileSelectedId.length === 0"
              class="dropdown-item"
              @click="setupSelectOneAction('action_list', null, null, null, typeActionList.REJECT_LIST)" color="danger">
              <i class="fa fa-close mr-2" style="font-size: 1rem!important;"></i>
              Hủy duyệt
            </button>
            <button :disabled="actionData.model.listFileSelectedId.length === 0" class="dropdown-item"
              @click="isShowModalChangeVolumeMultipleDevice = true" color="danger">
              <i class="fa fa-volume-up mr-2" style="font-size: 1rem!important;"></i>
              Thay đổi âm lượng
            </button>
            <button :disabled="actionData.model.listFileSelectedId.length === 0" class="dropdown-item"
              @click="configOnOffMultipleDevice()" color="danger">
              <i class="fa fa-wrench mr-2" style="font-size: 1rem!important;"></i>
              Cấu hình thời gian bật/tắt
            </button>
            <button :disabled="actionData.model.listFileSelectedId.length === 0" class="dropdown-item"
              @click="setupSelectOneAction('action_list', null, null, null, typeActionList.RESTART_LIST)" color="danger">
              <i class="fa fa-power-off mr-2" style="font-size: 1rem!important;"></i>
              Khởi động lại thiết bị
            </button>
            <button v-if="$hasAuthor('ROLE_ADMIN')" :disabled="actionData.model.listFileSelectedId.length === 0"
              class="dropdown-item"
              @click="setupSelectOneAction('action_list', null, null, null, typeActionList.UPDATE_APP_LIST)"
              color="danger">
              <i class="fa fa-download mr-2" style="font-size: 1rem!important;"></i>
              Cập nhật phần mềm
            </button>
          </div>
        </div>
      </CCol>


      <CCol v-if="$hasAuthor('ROLE_ADMIN')" xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseSelect :options="orgSelect.options" :data="orgSelect.data" ref="orgSelect"></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseSelect :options="connectStatusSelect.options" :data="connectStatusSelect.data" ref="connectStatusSelect">
        </BaseSelect>
      </CCol>
      <CCol v-if="!$hasAuthor('ROLE_ADMIN')" xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseSelect :options="activeStatusSelect.options" :data="activeStatusSelect.data" ref="activeStatusSelect">
        </BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseSelect :options="statusSelect.options" :data="statusSelect.data" ref="statusSelect"></BaseSelect>
      </CCol>
      <CCol v-if="!$hasAuthor('ROLE_ADMIN')" xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseInput :options="serialIdInput.options" :data="serialIdInput.data" />
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseInput :options="descriptionInput.options" :data="descriptionInput.data" />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton style="float: right;margin-left: 5px;" color="primary" v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary" @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp; Tải lại
            </CButton>
            <CButton v-if="$hasAuthor('ROLE_ADMIN')" style="float: right;margin-left: 5px;" color="primary"
              v-c-tooltip.hover="'Nhiệt độ'" class="btn-action-primary" @click="submitCheckTemperature()">
              <i class="fa fa-thermometer-full"></i>&nbsp; Nhiệt độ
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
          ref="mainTable">
          <template #checkbox="{ item }">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" v-model="actionData.model.listFileSelectedId"
                  :value="item.id" :id="item.id" />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </template>
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #serialId="{ item }">
            <td>
              <span :key="item.serialId" v-c-tooltip:hover="item.serialId" class="description">{{
                  item.serialId
              }}</span>
            </td>
          </template>
          <template #volume="{ item }">
            <td class="volume">

              <CDropdown color="p-1" placement="bottom-end" addMenuClasses="dropdown-volume"
                addTogglerClasses="custom-toggle-volume" :caret="false">
                <template #toggler-content>
                  <i class="fa" :class="generateIconVolume(item.volume)"
                    style="cursor: pointer;font-size: 16px!important;"></i>
                  <span class="ml-2">{{ item.volume }}
                  </span>
                </template>
                <CDropdownItem>
                  <range-slider class="slider" min="0" max="100" step="5" v-model="item.volume"
                    @change="changeVolume(item.id, item.volume)">
                  </range-slider>
                </CDropdownItem>
              </CDropdown>
            </td>
          </template>
          <template #updateDate="{ item }">
            <td>{{ $helper.formatDate(item.updateDate) }}</td>
          </template>
          <template #activeStatus="{ item }">
            <td>
              <span class="badge badge-success" v-if="item.activeStatus == 1">Hoạt động</span>
              <span class="badge badge-danger" v-if="item.activeStatus == 0">Không hoạt động</span>
            </td>
          </template>
          <template #temperature="{ item }">
            <td>
              <span class="badge" style="font-size: 15px"
                :style="(item.temperature != null && item.temperature != '' && item.temperature > 70) ? 'color:red' : 'color:black'">{{
                    (item.temperature != null && item.temperature != '' ? item.temperature : 0) + '℃'
                }}</span>
            </td>
          </template>
          <template #connectStatus="{ item }">
            <td>
              <span class="badge badge-success" v-if="item.connectStatus == 1">Kết nối</span>
              <span class="badge badge-danger" v-if="item.connectStatus == 0">Mất kết nối</span>
            </td>
          </template>
          <template #status="{ item }">
            <td>
              <span v-if="item.status == 1" class="dot-custom dot-success">
                Đã duyệt
                <BaseSwitch v-if="$hasAuthor('ROLE_ADMIN')" class="mx-1" color="success" checked variant="3d"
                  v-c-tooltip.hover="'Hủy duyệt'" v-bind="labelIcon"
                  @update:checked="setupSelectOneAction('update_status', item.id, item.serialId, item.status)" />
              </span>
              <span v-else class="dot-custom dot-danger">
                Chưa duyệt
                <BaseSwitch v-if="$hasAuthor('ROLE_ADMIN')" class="mx-1" color="danger" variant="3d"
                  v-c-tooltip.hover="'Duyệt'" v-bind="labelIcon"
                  @update:checked="setupSelectOneAction('update_status', item.id, item.serialId, item.status)" />
              </span>
            </td>
          </template>
          <template #action="{ item }">
            <td class="action-btn-group">

              <!--              addMenuClasses="custom-scroll action-custom"-->

              <CDropdown color="p-1" placement="bottom-end" addTogglerClasses="" :caret="false">
                <template #toggler-content>
                  <!--                  <CIcon name="cil-list" class=" pr-1"/>-->
                  <!--                  Thao tác-->
                  <i class="fa fa-list-ul" style="font-size: 15px!important;"></i>
                </template>
                <CDropdownItem class="group-btn-action">
                  <div class="action-btn-wrapper">
                    <CButton color="info" v-if="$hasAuthor('ROLE_ADMIN')" variant="outline"
                      v-c-tooltip.hover="{ placement: 'bottom', content: 'Chuyển đầu ra âm thanh' }" square size="sm"
                      @click="setupSelectOneAction('change_input_volume', item.id, item.serialId)">
                      <i class="fa fa-gears" />
                    </CButton>
                    <CButton color="info" v-if="$hasAuthor('ROLE_ADMIN')" variant="outline"
                      v-c-tooltip.hover="{ placement: 'bottom', content: 'Cập nhật phần mềm' }" square size="sm"
                      @click="setupSelectOneAction('update_app', item.id, item.serialId)">
                      <i class="fa fa-download" />
                    </CButton>
                    <CButton color="info" variant="outline"
                      v-c-tooltip.hover="{ placement: 'bottom', content: 'Cấu hình thời gian bật/tắt' }" square size="sm"
                      @click="clickConfigTimeOnOffDevice(item)">
                      <i class="fa fa-wrench" />
                    </CButton>
                    <CButton color="info" variant="outline"
                      v-c-tooltip.hover="{ placement: 'bottom', content: 'Đồng bộ lại trình diễn' }" square size="sm"
                      @click="asyncSlideShowDevice(item.id)">
                      <i class="fa fa-refresh" />
                    </CButton>
                    <CButton color="info" variant="outline"
                      v-c-tooltip.hover="{ placement: 'bottom', content: 'Khởi động lại thiết bị' }" square size="sm"
                      @click="restartDevice(item.id)">
                      <i class="fa fa-power-off" />
                    </CButton>
                    <CButton color="info" variant="outline"
                      v-c-tooltip.hover="{ placement: 'bottom', content: 'Cập nhật mô tả' }" square size="sm"
                      @click="updateDescription(item.id, item.description)">
                      <CIcon name="cil-pencil" />
                    </CButton>
                    <CButton color="info" v-if="$hasAuthor('ROLE_ADMIN')" variant="outline" square size="sm"
                      v-c-tooltip.hover="{ placement: 'bottom', content: 'Xóa' }"
                      @click="setupSelectOneAction('delete_one', item.id, item.serialId)">
                      <CIcon name="cil-trash" />
                    </CButton>
                  </div>
                </CDropdownItem>
              </CDropdown>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>

    <BaseModal title="Thay đổi âm lượng các thiết bị" :isFooter="false"
      :show.sync="isShowModalChangeVolumeMultipleDevice" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <span style="display: flex;justify-content: center; font-weight: 500;font-size: 20px;">
            {{ volumeChangeMultipleDevice }}</span>
          <range-slider class="slider" min="0" max="100" step="5" v-model="volumeChangeMultipleDevice"
            style="width: 100%;max-width: unset" @change="changeVolume(null, volumeChangeMultipleDevice)">
          </range-slider>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModalUpdateDescription = false"><i
            class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitUpdateDescription()"><i class="fa fa-check"></i> Cập
          nhật
        </button>
      </template>
    </BaseModal>

    <CModal title="Cập nhật mô tả thiết bị" :show.sync="isShowModalUpdateDescription" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseTextArea :options="dataDescription.descriptionInput.options"
            :data="dataDescription.descriptionInput.data" v-model="dataDescription.descriptionInput.data.model" />
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModalUpdateDescription = false"><i
            class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitUpdateDescription()"><i class="fa fa-check"></i> Cập
          nhật
        </button>
      </template>
    </CModal>

    <CModal title="Cập nhật thời gian bật/tắt màn hình" :show.sync="isShowModalTimeOnOff" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="6" xl="6" xs="6">
          <div class="form-group">
            <label for="timeOn">Thời gian bật <span class="required">*</span></label>
            <DatePicker class="mt-2" id="timeOn" mode="time" v-model="dataTimeOnOff.timeOn"
              :masks="{ input: 'HH:MM', data: 'HH:MM' }" is24hr>
            </DatePicker>
          </div>
        </CCol>
        <CCol sm="12" md="6" xl="6" xs="6">
          <div class="form-group">
            <label for="timeOff">Thời gian tắt <span class="required">*</span></label>
            <DatePicker class="mt-2" id="timeOff" mode="time" v-model="dataTimeOnOff.timeOff"
              :masks="{ input: 'HH:MM', data: 'HH:MM' }" is24hr>
            </DatePicker>
          </div>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModalTimeOnOff = false"><i
            class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" :disabled="dataTimeOnOff.disable"
          @click="submitUpdateTimeOnOff()">
          <i class="fa" :class="dataTimeOnOff.disable == true ? 'fa-spin fa-spinner' : 'fa-check'"></i> Cập
          nhật
        </button>
      </template>
    </CModal>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2";
import BaseSwitch from "../base/BaseSwitch";
import BaseTextArea from "../base/BaseTextArea";
import BaseFormLoading from "../base/BaseFormLoading";
import RangeSlider from 'vue-range-slider'
import { TypeActionFileList, USER_NAME } from '../../constant';
import { DatePicker } from "v-calendar";
import BaseModal from "@/views/base/BaseModal";

export default {
  name: "DeviceList",
  components: {
    BaseModal,
    BaseTable,
    BaseInput,
    BaseSelect,
    BaseSwitch,
    ModalConfirm,
    BaseTextArea,
    BaseFormLoading,
    RangeSlider,
    DatePicker
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();
    actionTypeMapping.set("delete_one", {
      url: "/devices/delete",
      titlePopup: function () {
        return that.$helper.setupTitleAction("xóa", "thiết bị", that.actionData.model.deviceSelectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return { id: that.actionData.model.deviceSelectedId };
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({ message: "Xóa thiết bị " + that.actionData.model.deviceSelectedName + " thành công" });
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("change_input_volume", {
      url: "/devices/changeInputVolume",
      titlePopup: function () {
        return that.$helper.setupTitleAction("chuyển đổi âm thanh đầu vào HDMI", "thiết bị", that.actionData.model.deviceSelectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return { id: that.actionData.model.deviceSelectedId };
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({ message: "Chuyển đổi âm thanh đầu vào HDMI " + that.actionData.model.deviceSelectedName + " thành công" });
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("update_app", {
      url: "/devices/update-app",
      titlePopup: function () {
        return that.$helper.setupTitleAction("cập nhật phần mềm", "thiết bị", that.actionData.model.deviceSelectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return { id: that.actionData.model.deviceSelectedId };
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({ message: "Cập nhật phần mềm " + that.actionData.model.deviceSelectedName + " thành công" });
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("update_status", {
      url: "/devices/updateStatus",
      titlePopup: function () {
        return that.$helper.setupTitleAction(that.actionData.model.status == true ? "hủy duyệt" : "duyệt", "thiết bị", that.actionData.model.deviceSelectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.deviceSelectedId, userName: localStorage.getItem(USER_NAME)
        };
      },
      successCallback: function () {
        that.showSuccessMsg({ message: that.actionData.model.status == true ? "Hủy duyệt thiết bị thành công" : "Duyệt thiết bị thành công" });
        that.loadDataMainTable();
      },
    });

    actionTypeMapping.set("action_list", {
      url: "/devices/actionList",
      titlePopup: function () {
        switch (that.actionData.model.type) {
          case TypeActionFileList.DELETE_LIST: {
            return that.$helper.setupTitleAction("xóa", "các thiết bị", "đã chọn");
          }
          case TypeActionFileList.ACCEPT_LIST: {
            return that.$helper.setupTitleAction("duyệt", "các thiết bị", "đã chọn");
          }
          case TypeActionFileList.REJECT_LIST: {
            return that.$helper.setupTitleAction("hủy duyệt", "các thiết bị", "đã chọn");
          }
          case TypeActionFileList.RESTART_LIST: {
            return that.$helper.setupTitleAction("khởi động lại", "các thiết bị", "đã chọn");
          }
          case TypeActionFileList.UPDATE_APP_LIST: {
            return that.$helper.setupTitleAction("cập nhật phần mềm", "các thiết bị", "đã chọn");
          }
        }
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          ids: that.actionData.model.listFileSelectedId,
          type: that.actionData.model.type
        };
      },
      successCallback: function () {
        that.actionData.model.listFileSelectedId = [];
        switch (that.actionData.model.type) {
          case TypeActionFileList.DELETE_LIST: {
            that.showSuccessMsg({ message: "Xóa danh sách thiết bị thành công" });
            break;
          }
          case TypeActionFileList.ACCEPT_LIST: {
            that.showSuccessMsg({ message: "Duyệt danh sách thiết bị thành công" });
            break;
          }
          case TypeActionFileList.REJECT_LIST: {
            that.showSuccessMsg({ message: "Hủy danh sách thiết bị thành công" });
            break;
          }
          case TypeActionFileList.RESTART_LIST: {
            that.showSuccessMsg({ message: "Khởi động lại danh sách thiết bị thành công" });
            break;
          }
          case TypeActionFileList.UPDATE_APP_LIST: {
            that.showSuccessMsg({ message: "Cập nhật phần mềm danh sách thiết bị thành công" });
            break;
          }
        }
        that.loadDataMainTable();
      },
    });

    return {
      loading: { value: false },
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      typeActionList: TypeActionFileList,
      isShowModalTimeOnOff: false,
      isShowModalChangeVolumeMultipleDevice: false,
      isShowModalUpdateDescription: false,
      volumeChangeMultipleDevice: 50,
      piAction: {},
      dataDescription: {
        id: null,
        descriptionInput: {
          options: {
            label: "Mô tả thiết bị",
            placeholder: "Mô tả thiết bị",
            maxlength: 2000,
            rows: 5
          },
          data: {
            name: "description",
            model: "",
            updateCallback: function () {
              that.submitUpdateDescription();
            }
          }
        }
      },
      orgSelect: {
        options: {
          label: "Đơn vị",
          selectAllText: "Tất cả đơn vị",
          filter: true,
          keyField: "value",
          valueField: "text",
          lazyLoad: that.$hasAuthor("ROLE_ADMIN") ? false : true
        },
        data: {
          model: "",
          name: "orgId",
          source: {
            url: "/organization/list-org-active",
            response: function (dataResponse) {
              return dataResponse.data;
            },
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      dataTimeOnOff: {
        id: null,
        timeOn: null,
        timeOff: null,
        disable: false,
      },
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          deviceSelectedId: null,
          deviceSelectedName: null,
          status: null,
          listFileSelectedId: [],
          type: null
        }
      },
      serialIdInput: {
        options: {
          placeholder: "Mã thiết bị",
          label: 'Mã thiết bị'
        },
        data: {
          name: "serialId",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      descriptionInput: {
        options: {
          placeholder: "Mô tả",
          label: 'Mô tả'
        },
        data: {
          name: "description",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      connectStatusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái kết nối',
        },
        data: {
          name: "connectStatus",
          items: [
            { key: "-1", value: "Tất cả" },
            { key: "1", value: "Kết nối" },
            { key: "0", value: "Mất kết nối" },
          ],
          model: "-1",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      activeStatusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái hoạt động',
        },
        data: {
          name: "activeStatus",
          items: [
            { key: "-1", value: "Tất cả" },
            { key: "1", value: "Hoạt động" },
            { key: "0", value: "Không hoạt động" },
          ],
          model: "-1",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      statusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái',
        },
        data: {
          name: "status",
          items: [
            { key: "-1", value: "Tất cả" },
            { key: "1", value: "Đã duyệt" },
            { key: "0", value: "Chờ duyệt" },
          ],
          model: "-1",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      mainTable: {
        options: {
          fields: null,
          slots: ["checkbox", "index", "serialId", "volume", "activeStatus", "temperature", "connectStatus", "updateDate", "status", "action"],
        },
        dataSource: {
          url: "/devices/getPages",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      }
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter, isLoading) {
      this.$refs.mainTable.loadData(isUpdateFilter, isLoading);
    },
    changeSelectAll: function () {
      if (this.actionData.model.selectedAll) {
        this.actionData.model.listFileSelectedId = [];
        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listFileSelectedId.push(each.id);
        });
      } else {
        this.actionData.model.listFileSelectedId = [];
      }
    },
    submitCheckTemperature() {
      let that = this;
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/devices/checkTemperature",
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.showSuccessMsg({ message: "Kiểm tra nhiệt độ thành công" });
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    generateIconVolume(volume) {
      if (volume == 0) {
        return 'fa-volume-off'
      } else if (volume < 50) {
        return 'fa-volume-down'
      } else {
        return 'fa-volume-up'
      }
    },
    setupSelectOneAction: function (actionTypeKey, deviceId, deviceName, status, type) {
      let actionData = this.actionData.model;
      actionData.deviceSelectedId = deviceId || null;
      actionData.deviceSelectedName = deviceName || null;
      actionData.status = status || null;
      actionData.type = type || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    configOnOffMultipleDevice() {
      this.dataTimeOnOff.timeOn = new Date().setHours(0, 0, 0);
      this.dataTimeOnOff.timeOff = new Date().setHours(0, 0, 0);
      this.isShowModalTimeOnOff = true;
    },
    clickConfigTimeOnOffDevice(item) {
      this.dataTimeOnOff.id = item.id;
      this.dataTimeOnOff.timeOn = new Date(this.$helper.convertStringTimeToDate(item.timeOn, "hh:mm:ss"));
      this.dataTimeOnOff.timeOff = new Date(this.$helper.convertStringTimeToDate(item.timeOff, "hh:mm:ss"));
      this.isShowModalTimeOnOff = true;
    },
    changeVolume(id, _volume) {
      let that = this;
      this.loading.value = true;
      this.$helper.loadDataSource({
        url: "/devices/updateVolume",
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            deviceId: id || '',
            volume: _volume,
            deviceIds: that.actionData.model.listFileSelectedId
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Thay đổi âm lượng thành công"
            });
            that.loadDataMainTable(false, false);
            that.loading.value = false;
            that.isShowModalChangeVolumeMultipleDevice = false;
            that.actionData.model.listFileSelectedId = [];
            $('body').click();
          }
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    restartDevice(id) {
      let that = this;
      this.loading.value = true;
      this.$helper.loadDataSource({
        url: "/devices/restart",
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            deviceId: id
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Khởi động lại thiết bị thành công"
            });
            that.loadDataMainTable(false, false);
            that.loading.value = false;
          }
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    asyncSlideShowDevice(id) {
      let that = this;
      this.loading.value = true;
      this.$helper.loadDataSource({
        url: "/devices/asyncSlideShow",
        isJsonContentType: false,
        ignoreDefaultData: true,
        dataSubmit: function () {
          return {
            deviceId: id
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Đồng bộ trình diễn thiết bị thành công"
            });
            that.loading.value = false;
          }
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    updateDescription(id, description) {
      this.isShowModalUpdateDescription = true;
      this.dataDescription.id = id;
      this.dataDescription.descriptionInput.data.model = description;
    },
    submitUpdateDescription() {
      let that = this;
      this.$helper.loadDataSource({
        url: "/devices/updateDescription",
        dataSubmit: function () {
          return {
            id: that.dataDescription.id,
            description: that.dataDescription.descriptionInput.data.model
          };
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({ message: "Cập nhật mô tả thiết bị thành công" });
            that.isShowModalUpdateDescription = false;
            that.loadDataMainTable(false, true);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitUpdateTimeOnOff() {
      let that = this;
      that.dataTimeOnOff.disable = true;
      this.$helper.loadDataSource({
        url: "/devices/configTimeOnOff",
        dataSubmit: function () {
          return {
            id: that.dataTimeOnOff.id || "",
            timeOn: that.$helper.formatDate(that.dataTimeOnOff.timeOn),
            timeOff: that.$helper.formatDate(that.dataTimeOnOff.timeOff),
            deviceIds: that.actionData.model.listFileSelectedId
          };
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({ message: "Cấu hình thời gian bật/tắt thiết bị thành công" });
            that.isShowModalTimeOnOff = false;
            that.loadDataMainTable(false, true);
          }
          that.dataTimeOnOff.disable = false;
          that.actionData.model.listFileSelectedId = [];
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.dataTimeOnOff.disable = false;
        }
      });
    }
  },
  created: function () {
  },
  mounted() {
    if (this.$hasAuthor("ROLE_ADMIN")) {
      this.mainTable.options.fields = [
        // {key: "index", label: "STT"},
        { key: "checkbox", label: "#" },
        { key: "updateDate", label: "Cập nhật cuối", _style: "width:10%" },
        { key: "serialId", label: "Mã thiết bị" },
        { key: "activeStatus", label: "Trạng thái hoạt động" },
        { key: "connectStatus", label: "Trạng thái kết nối" },
        { key: "temperature", label: "Nhiệt độ" },
        { key: "ipAddress", label: "IP Address" },
        { key: "description", label: "Mô tả", _style: "min-width:15%" },
        { key: "volume", label: "Âm lượng", _style: "width:8%;" },
        { key: "status", label: "Trạng thái", _style: "width:10%" },
        { key: "action", label: "Thao tác" },
      ]
    } else {
      this.mainTable.options.fields = [
        { key: "checkbox", label: "#" },
        { key: "updateDate", label: "Cập nhật cuối", _style: "width:10%" },
        { key: "serialId", label: "Mã thiết bị" },
        { key: "activeStatus", label: "Trạng thái hoạt động" },
        { key: "connectStatus", label: "Trạng thái kết nối" },
        { key: "description", label: "Mô tả", _style: "min-width:15%" },
        { key: "volume", label: "Âm lượng", _style: "width:8%;" },
        { key: "status", label: "Trạng thái", _style: "width:10%" },
        { key: "action", label: "Thao tác" },
      ]
    }
  },
  watch: {
    "actionData.model.listFileSelectedId": function (newValue) {
      let that = this;
      if (newValue.length === that.$refs.mainTable.items.length) {
        that.actionData.model.selectedAll = true;
      } else {
        that.actionData.model.selectedAll = false;
      }
    }
  },
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
<style lang="scss">
@import '~vue-range-slider/dist/vue-range-slider.scss';

.slider {
  width: 200px;
  max-width: 200px;
  //padding: 0 !important;
}

.range-slider-rail,
.range-slider-fill {
  height: 6px !important;
}

.range-slider-fill {
  background-color: #0b98ff;
}

.range-slider-knob {
  width: 15px !important;
  height: 15px !important;
}

.range-slider {
  padding: unset !important;
}

.dropdown-volume {
  padding: unset;
  border-radius: 50px;
}

.dropdown-volume a:hover {
  background: none !important;
}

.custom-toggle-volume {
  min-width: 70px;
  display: inline-flex !important;
  justify-content: center;
}

.volume .dropdown {
  display: inline-flex !important;
}

.action-custom {
  height: 200px;
  overflow: auto;
}

.group-btn-action {
  height: 35px;
}

.group-btn-action:hover {
  background: unset !important;
}
</style>
